import VuexErrors from 'src/vuex/modules/errors'
import Api from 'fou-api'
import Errors from 'src/utils/helper/errors'
import { DATE_RANGE_DROPDOWN_DEFAULT_DAYS } from 'src/utils/constants/common'
import Misc from 'src/utils/helper/misc'
import { isEqual } from 'lodash'
import { requestObj } from 'src/pages/sales-report/scripts/earningsreportRequest'

export default {
  namespaced: true,

  state() {
    return {
      dateRangeDays: DATE_RANGE_DROPDOWN_DEFAULT_DAYS,
      salesType: 'earning',
      startDate: requestObj.fromDate,
      endDate: requestObj.toDate,
      earningGraphData: null,
      orderGraphData: null,
      graphMetaData: null,
      earningTotal: null,
      highestEarningDate: null,
      topEarningFont: null,
      topEarningLicence: null,
      totalOrders: null,
      discountedOrders: null,
      topLicenseSold: null,
      topOrderCountry: null,
      topPerformingFamilies: null,
      reportType: 'earnings',
      foundryLogo: null,
      foundryPoster: null,
      loadingReport: false,
      ufda2Status: false,
      viewedFromReportBtn: false,
      showAgreementModal: false,
      scrollToArticles: false
    }
  },

  getters: {
    getDateRangeDays: state => state.dateRangeDays,
    getSalesType: state => state.salesType,
    getStartDate: state => state.startDate,
    getEndDate: state => state.endDate,
    getEarningGraphData: state => state.earningGraphData,
    getOrderGraphData: state => state.orderGraphData,
    getEarningTotal: state => state.earningTotal,
    getHighestEarningDate: state => state.highestEarningDate,
    getTopEarningFont: state => state.topEarningFont,
    getTopEarningLicence: state => state.topEarningLicence,
    getTotalOrders: state => state.totalOrders,
    getDiscountedOrders: state => state.discountedOrders,
    getTopLicenseSold: state => state.topLicenseSold,
    getTopOrderCountry: state => state.topOrderCountry,
    getTopPerformingFamilies: state => state.topPerformingFamilies,
    getGraphMetaData: state=> state.graphMetaData,
    getReportType: state=> state.reportType,
    getFoundryLogo: state => state.foundryLogo,
    getFoundryPoster: state => state.foundryPoster,
    getLoadingReport: state => state.loadingReport,
    getUfda2Status: state => state.ufda2Status,
    getViewedFromReportBtn: state => state.viewedFromReportBtn,
    getShowAgreementModal: state => state.showAgreementModal,
    getScrollToArticles: state => state.scrollToArticles
  },

  mutations: {
    setDateRangeDays(state, dateRangeDays) {
      state.dateRangeDays = dateRangeDays
    },
    setSalesType(state, salesType) {
      state.salesType = salesType
    },
    setStartDate(state, startDate) {
      state.startDate = startDate
    },
    setEndDate(state, endDate) {
      state.endDate = endDate
    },
    setEarningGraphData(state, earningGraphData) {
      state.earningGraphData = earningGraphData
    },
    setOrderGraphData(state, orderGraphData) {
      state.orderGraphData = orderGraphData
    },
    setEarningTotal(state, earningTotal) {
      state.earningTotal = earningTotal
    },
    setHighestEarningDate(state, highestEarningDate) {
      state.highestEarningDate = highestEarningDate
    },
    setTopEarningFont(state, topEarningFont) {
      state.topEarningFont = topEarningFont
    },
    setTopEarningLicence(state, topEarningLicence) {
      state.topEarningLicence = topEarningLicence
    },
    setTotalOrders(state, totalOrders) {
      state.totalOrders = totalOrders
    },
    setDiscountedOrders(state, discountedOrders) {
      state.discountedOrders = discountedOrders
    },
    setTopLicenseSold(state, topLicenseSold) {
      state.topLicenseSold = topLicenseSold
    },
    setTopOrderCountry(state, topOrderCountry) {
      state.topOrderCountry = topOrderCountry
    },
    setTopPerformingFamilies(state, topPerformingFamilies) {
      state.topPerformingFamilies = topPerformingFamilies
    },
    setGraphMetaData(state, payload){
      state.graphMetaData = payload
    },
    setReportType(state,payload){
      state.reportType = payload
    },
    setFoundryLogo (state, foundryLogo) {
      state.foundryLogo = foundryLogo
    },
    setFoundryPoster (state, foundryPoster) {
      state.foundryPoster = foundryPoster
    },
    setLoadingReport(state, payload) {
      state.loadingReport = payload
    },
    setUfda2Status(state, payload) {
      state.ufda2Status = payload
    },
    setViewedFromReportBtn(state, payload) {
      state.viewedFromReportBtn = payload
    },
    setShowAgreementModal(state, payload) {
      state.showAgreementModal = payload
    },
    setScrollToArticles(state, payload) {
      state.scrollToArticles = payload
    }
  },

  actions: {
    async updateDateRangeDays({ commit, state, dispatch }) {
      // commit('setDateRangeDays', dateRangeDays)
      await dispatch('fetchSalesReportSummary')
      commit('setGraphMetaData', null)
      if (isEqual(state.reportType, 'earnings')) {
        await dispatch('modifiedEarningGraphData')
      } else {
        await dispatch('modifiedOrderGraphData')
      }
    },
    async fetchSalesReportSummary({ commit, state, rootGetters }) {
      try {
        commit('setLoadingReport', true) // Start setting earnings, orders and top performer data.
        // commit('setEndDate')
        // commit('setStartDate')

        const userId = rootGetters['auth/user'].userId
        const requestData = {
          filter: {
            isFilter: true,
            salesType: state.salesType,
            foundryIds: [rootGetters['profile/sessionFoundryId']],
            date: {
              fromDate: state.startDate,
              toDate: state.endDate
            }
          },
          searchQuery: ''
        }

        const response = await Api.SalesReport.getSalesReportSummary(userId, requestData)
        const responseData = response.data
        const modifiedEarningyAxis = responseData.graphData.yAxisEarning?.map(element => element.replace('$', ''))

        // Common
        commit('setEarningGraphData', {xAxis: responseData.graphData.xAxis, yAxis: modifiedEarningyAxis})
        commit('setOrderGraphData', {xAxis: responseData.graphData.xAxis, yAxis: responseData.graphData.yAxisOrder})

        // Earnings
        commit('setEarningTotal', responseData.totalAmount)
        commit('setHighestEarningDate', responseData.highestSale)
        commit('setTopEarningFont', responseData.topFont)
        commit('setTopEarningLicence', responseData.topLicense)
        
        // Orders
        commit('setTotalOrders', responseData.totalOrders)
        commit('setDiscountedOrders', responseData.discountedOrders)
        commit('setTopLicenseSold', responseData.topLicenseSold)
        commit('setTopOrderCountry', responseData.topOrderCountry)

        // Top Performer
        commit('setTopPerformingFamilies', responseData.topPerformingFamilies)

        // Finished setted earnings, orders and top performer data.
        commit('setLoadingReport', false)
      } catch (error) {
        commit('setLoadingReport', false)
        const err = Errors.create(error)
        commit('errors/add', err)
        throw err
      }
    },
    modifiedOrderGraphData({state, commit}){
      const modifiedData =  {
        label: 'total_orders',
        total: state.totalOrders,
        topData:[
          {
            label: 'promotion_orders',
            value: state.discountedOrders,
          },
          {
            label: 'top_license_sold',
            value: state.topEarningLicence?.licenseType,
          },
          {
            label: 'top_order_country',
            value: state.topOrderCountry,
          }
        ]
      }
      commit('setGraphMetaData', modifiedData)
    },
    modifiedEarningGraphData({state, commit}){
      let earningTotalAmount, highestEarningSaleAmount, topEarningFontSaleAmount, topEarningLicenceSaleAmount
      if (state.earningTotal ){
        earningTotalAmount = state.earningTotal.length ? Misc.getAmount(state.earningTotal[0].amount, state.earningTotal[0].currency) : 0
        highestEarningSaleAmount = state.earningTotal.length ? Misc.getAmount(state.highestEarningDate.saleAmount[0].amount, state.highestEarningDate.saleAmount[0].currency) : 0
        topEarningFontSaleAmount = state.earningTotal.length ? Misc.getAmount(state.topEarningFont.saleAmount[0].amount, state.topEarningFont.saleAmount[0].currency) : 0
        topEarningLicenceSaleAmount = state.earningTotal.length ? Misc.getAmount(state.topEarningLicence.saleAmount[0 ].amount, state.topEarningLicence.saleAmount[0].currency) : 0
      }
      const modifiedData =  {
        label: 'total_earnings',
        total: earningTotalAmount,
        topData:[
          {
            label: 'highest_sales',
            value: highestEarningSaleAmount,
            data: state.highestEarningDate ? Misc.formatDate(state.highestEarningDate.saleDate,'','MMM D, YYYY') : null
          },
          {
            label: 'top_font',
            value: topEarningFontSaleAmount,
            data: state.topEarningFont?.fontName
          },
          {
            label: 'top_license_type',
            value: topEarningLicenceSaleAmount,
            data: state.topEarningLicence?.licenseType
          }
        ]
      }
      commit('setGraphMetaData', modifiedData)
    },
    setReportDataNull({commit}){
      commit('setEarningGraphData', null)
      commit('setOrderGraphData', null)
      commit('setGraphMetaData', null)
      commit('setEarningTotal', null)
      commit('setHighestEarningDate', null)
      commit('setTopEarningFont', null)
      commit('setTopEarningLicence', null)
      commit('setTotalOrders', null)
      commit('setDiscountedOrders', null)
      commit('setTopLicenseSold', null)
      commit('setTopOrderCountry', null)
      commit('setTopPerformingFamilies', null)
      commit('setLoadingReport', false)
    }
  },

  modules: {
    errors: VuexErrors
  }
}
